// extracted by mini-css-extract-plugin
module.exports = {"item":"DressItem_style_item__XxHlV","content":"DressItem_style_content__1j3wd"};